import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      await axios.post(
        `${process.env.REACT_APP_STRAPI_URL}/api/auth/local/register`,
        {
          username,
          email,
          password,
        }
      );
      setSuccess(
        "Usuario registrado correctamente. Ahora puedes iniciar sesión."
      );
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setError(
        "Error al registrar usuario. Verifica los datos o si el usuario ya existe."
      );
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Registro de Usuario</h1>
      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-4 w-80"
      >
        <input
          type="text"
          placeholder="Nombre de usuario"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="border p-2 rounded"
          required
        />
        <input
          type="email"
          placeholder="Correo electrónico"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border p-2 rounded"
          required
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="border p-2 rounded"
          required
        />
        <button
          type="submit"
          className="bg-green-600 text-white p-2 rounded font-bold hover:bg-green-700 transition"
        >
          Registrarse
        </button>
        {error && (
          <div className="text-red-600 text-center">{error}</div>
        )}
        {success && (
          <div className="text-green-600 text-center">{success}</div>
        )}
      </form>
      <p className="mt-4">
        ¿Ya tienes cuenta?{" "}
        <a
          href="/login"
          className="text-blue-600 underline"
        >
          Inicia sesión
        </a>
      </p>
    </div>
  );
}
